// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminHeader-adminHeaderContainer-wu7x_ {
    position: fixed;
    left: var(--sideMenu-width);
    right: 0;
    background-color: var(--primary-white-bg);
    z-index: 1030;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    border-bottom: 1px solid var(--primary-border);
    padding: 24px;
    height: var(--siteAdmin-header-height);
}

.AdminHeader-adminHeaderMenuIcon-Dv1HH {
    display: none;
}

.AdminHeader-hamburger-FqNfk .AdminHeader-iconBar-F9NY1 {
    display: block;
    width: 100%;
    height: 3px;
    background: var(--common-text-color);
    -webkit-transition: .3s;
    transition: .3s;
}

.AdminHeader-hamburger-FqNfk .AdminHeader-iconBar-F9NY1+.AdminHeader-iconBar-F9NY1 {
    margin-top: 4px;
}

.AdminHeader-hamburger-FqNfk {
    width: 25px;
}

@media (max-width: 1199px) {
    .AdminHeader-adminHeaderContainer-wu7x_ {
        left: 0;
        right: 0;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
    }

    .AdminHeader-adminHeaderMenuIcon-Dv1HH {
        display: inline-block;
        cursor: pointer;
    }
}

@media (max-width: 767px) {
    .AdminHeader-adminHeaderContainer-wu7x_ {
        padding: 24px 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/AdminHeader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,2BAA2B;IAC3B,QAAQ;IACR,yCAAyC;IACzC,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,uBAAe;IAAf,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,OAAO;QACP,QAAQ;QACR,yBAA8B;YAA9B,sBAA8B;gBAA9B,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".adminHeaderContainer {\n    position: fixed;\n    left: var(--sideMenu-width);\n    right: 0;\n    background-color: var(--primary-white-bg);\n    z-index: 1030;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    border-bottom: 1px solid var(--primary-border);\n    padding: 24px;\n    height: var(--siteAdmin-header-height);\n}\n\n.adminHeaderMenuIcon {\n    display: none;\n}\n\n.hamburger .iconBar {\n    display: block;\n    width: 100%;\n    height: 3px;\n    background: var(--common-text-color);\n    transition: .3s;\n}\n\n.hamburger .iconBar+.iconBar {\n    margin-top: 4px;\n}\n\n.hamburger {\n    width: 25px;\n}\n\n@media (max-width: 1199px) {\n    .adminHeaderContainer {\n        left: 0;\n        right: 0;\n        justify-content: space-between;\n    }\n\n    .adminHeaderMenuIcon {\n        display: inline-block;\n        cursor: pointer;\n    }\n}\n\n@media (max-width: 767px) {\n    .adminHeaderContainer {\n        padding: 24px 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminHeaderContainer": `AdminHeader-adminHeaderContainer-wu7x_`,
	"adminHeaderMenuIcon": `AdminHeader-adminHeaderMenuIcon-Dv1HH`,
	"hamburger": `AdminHeader-hamburger-FqNfk`,
	"iconBar": `AdminHeader-iconBar-F9NY1`
};
module.exports = ___CSS_LOADER_EXPORT___;
